import { user_data } from 'src/stores/account/user';
import { get } from 'svelte/store';

const serverUrls = {
	repo: 'https://repo.shelly.cloud',
	t1: 'https://shelly-t1-eu.shelly.cloud',
	nb: 'https://shellynb-1-eu.shelly.cloud',
};

export const DEV_SERVER_TAGS = Object.keys(serverUrls) as ServerType[];

export function isProductionUser(): boolean {
	const userApiUrl = get(user_data).user_api_url;
	const regex = /^https:\/\/shelly-\d+-eu\.shelly\.cloud$/;
	return regex.test(userApiUrl);
}

export function isRepoUser(): boolean {
	return get(user_data).user_api_url === serverUrls.repo;
}

export function isT1User(): boolean {
	return get(user_data).user_api_url === serverUrls.t1;
}

export function isNBserverUser(): boolean {
	return get(user_data).user_api_url === serverUrls.nb;
}

export type ServerType = keyof typeof serverUrls;

export function isDevServerUser(servers: ServerType[]): boolean {
	const userApiUrl = get(user_data).user_api_url;
	return servers.some((server) => userApiUrl === serverUrls[server]);
}
